!function () {
    let $form = $('#remform');

    if ($form.length) {
        // alert('remform exist');
        $form.off('submit').on('submit', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation(); // 2
            thisform = $(this);
            // console.log('submit');
            var data = $(this).serialize();
            if (thisform.find('.has-error').length == 0) {

                $.ajax({
                    url: '/mark/rem',
                    type: 'POST',
                    data: data,
                    success: function (res) {
                        var inst = $('[data-remodal-id=successrem]').remodal();
                        if (res.flag.send == true) {
                            inst.open();
                            thisform.find('#remform-name').val('');
                            thisform.find('#remform-phone').val('');
                            thisform.find('.app-form__btn').text('Выбрать дату и время');
                        }
                    },
                    error: function () {
                        alert('Ошибка отправки запроса!');
                    }
                });

            }
            return false;

        });
    }
}();
